const showSnackbar = id => {
  const snackbar = document.getElementById(id)
  snackbar.classList.add('Snackbar-show')

  setTimeout(() => {
    snackbar.classList.remove('Snackbar-show')
  }, 3000)
}

export default showSnackbar
